import { actionTypes } from '../actions/error';
import { useSelector } from 'react-redux';

const defaultState = {
  displayError: false,
  errorText: '',
};

const getError = s => s.error;
export const useError = () => useSelector(getError);

export default function error(state = defaultState, action = {}) {
  switch (action.type) {
    case actionTypes.SET_ERROR:
      return {
        ...state,
        displayError: true,
        errorText: action.error,
      };

    case actionTypes.RESET_ERROR:
      return defaultState;

    default:
      return state;
  }
}
